import { IApiManagement } from "@kuika/kuika-cl-model";
import * as React from "react";
import { KuikaListTableRowAction } from "../../ui-kit/kuika-list-table/kuika-list-table";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";

/**
 * What can be done to an API from a list of them: the landing table's row menu and the editor
 * switcher's "…" are this one list, so the two cannot offer different things.
 */
export const buildApiRowActions = (
  onRequestDelete: (api: IApiManagement) => void
): KuikaListTableRowAction<IApiManagement>[] => [
  {
    key: "delete",
    label: "Delete",
    icon: <KuikaSvg width={16} height={16} name="trash" />,
    danger: true,
    // The id the API list has always emitted for its delete item, kept explicitly rather than
    // left to the label-derived one the table would otherwise generate.
    dataTestId: "apiDeleteButton",
    onSelect: onRequestDelete
  }
];
